import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "./Cart.module.css";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function Cart({ onClose }) {
  const [cart, setCart] = useState({ items: [] }); // default empty cart
  const [loading, setLoading] = useState(true);

  const initCart = async () => {
    try {
      let cartId = localStorage.getItem("cartId");
      if (cartId) {
        const { data } = await axios.get(`${API_URL}/cart/cart/${cartId}`);
        console.log(data)
        setCart(data || { items: [] });
      } else {
        const { data } = await axios.post(`${API_URL}/cart/cart`);
        localStorage.setItem("cartId", data.cartId);
        setCart(data || { items: [] });
      }
    } catch (err) {
      console.error("Error initializing cart", err);
      setCart({ items: [] });
    } finally {
      setLoading(false);
    }
  };

  const addItem = async (productId, quantity = 1) => {
    try {
      const cartId = localStorage.getItem("cartId");
      const { data } = await axios.post(`${API_URL}/cart/cart/${cartId}/items`, {
        productId,
        quantity,
      });
      setCart(data || { items: [] });
    } catch (err) {
      console.error("Error adding item", err);
    }
  };

  const updateQuantity = async (itemId, quantity) => {
    if (quantity < 1) return;
    try {
      const cartId = localStorage.getItem("cartId");
      const { data } = await axios.put(
        `${API_URL}/cart/cart/${cartId}/items/${itemId}`,
        { quantity },
      );
      setCart(data || { items: [] });
    } catch (err) {
      console.error("Error updating quantity", err);
    }
  };

  const removeItem = async (itemId) => {
    try {
      const cartId = localStorage.getItem("cartId");
      const { data } = await axios.delete(
        `${API_URL}/cart/cart/${cartId}/items/${itemId}`,
      );
      setCart(data || { items: [] });
    } catch (err) {
      console.error("Error removing item", err);
    }
  };

  const clearCart = async () => {
    try {
      const cartId = localStorage.getItem("cartId");
      
      await axios.delete(`${API_URL}/cart/cart/${cartId}`);
      localStorage.removeItem("cartId");
      setCart({ items: [] });
    } catch (err) {
      console.error("Error clearing cart", err);
    }
  };


  // inside component
  const handleCheckout = async () => {
    try {
      const cartId = localStorage.getItem("cartId");
      if (!cartId) return;

      let user = JSON.parse(localStorage.getItem("user"));
      
      const { data } = await axios.post(`${API_URL}/order/checkout/create-session`, {
        cartId,
        userId: user ? user.id : null
      });
      
      if (data.url) {
        window.location.href = data.url; // redirect user straight to Stripe
      } else {
        console.error("Checkout session URL not found in response.", data);
        alert("Failed to create checkout session.");
      }
    } catch (err) {
      console.error("Checkout error:", err);
      alert("Something went wrong. Please try again.");
    }
  };


  useEffect(() => {
    initCart();
  }, []);

  const items = cart?.items || [];
  const subtotal = items.reduce(
    (sum, item) => sum + item.price_snapshot * item.quantity,
    0,
  );
  const shipping = subtotal > 45 ? 0 : 3.99;
  const total = subtotal + shipping;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <aside className={styles.drawer} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeBtn} onClick={onClose}>
          &times;
        </button>
        <h2 className={styles.heading}>YOUR BAG</h2>

        {loading ? (
          <div className={styles.loading}>Loading...</div>
        ) : items.length === 0 ? (
          <div className={styles.empty}>Your cart is empty.</div>
        ) : (
          items.map((item) => (
            <div key={item.id} className={styles.cartItem}>
              <img
                src={item.image_url?.startsWith("https") && item.image_url ? item.image_url : "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png"}
                alt={item.name}
                className={styles.cartImg}
              />
              <div className={styles.cartDetails}>
                <div className={styles.cartName}>{item.title}</div>
                <div className={styles.cartPrice}>
                  £{item.price_snapshot}
                </div>
                <div className={styles.qtyControls}>
                  <button
                    onClick={() => updateQuantity(item.id, item.quantity - 1)}
                  >
                    -
                  </button>
                  <span>{item.quantity}</span>
                  <button
                    onClick={() => updateQuantity(item.id, item.quantity + 1)}
                  >
                    +
                  </button>
                </div>
              </div>
              <button
                className={styles.removeBtn}
                onClick={() => removeItem(item.id)}
              >
                Remove
              </button>
            </div>
          ))
        )}

        <div className={styles.summarySection}>
          <div className={styles.summaryRow}>
            <span>Sub Total</span>
            <span>£{subtotal.toFixed(2)}</span>
          </div>
          <div className={styles.summaryRow}>
            <span>Estimated Shipping</span>
            <span>£{shipping.toFixed(2)}</span>
          </div>
          <div className={styles.summaryRowTotal}>
            <span>TOTAL</span>
            <span>£{total.toFixed(2)}</span>
          </div>
        </div>

        <button className={styles.checkoutBtn} onClick={handleCheckout}>
          🛒 CHECKOUT
        </button>
      </aside>
    </div>
  );
}